import {
	mergeFilterInputs,
	StudentFilterInput,
	UserFilterInput,
	UserGroupFilterInput,
	UserStatus,
	useStudentNamesDescriptionsAndImagesQuery,
} from "../../../../../Utilities";
import { useUserAndUserGroupRecipients } from "../Recipients";

const personTypeFilter = {
	person: [{ or: [{ hasEmployee: true }, { hasGuardian: true }] }],
};

export function useRecipients(
	search?: string | null,
	userFilterInput?: UserFilterInput,
	userGroupFilterInput?: UserGroupFilterInput,
) {
	return useUserAndUserGroupRecipients(
		search,
		userFilterInput ? mergeFilterInputs(userFilterInput, personTypeFilter) : personTypeFilter,
		userGroupFilterInput,
	);
}

const baseStudentTopicRecipientFilter: StudentFilterInput = {
	relationships: [
		{
			guardian: [
				{
					person: [
						{
							user: [
								{
									statusNEQ: UserStatus.Disabled,
								},
							],
						},
					],
				},
			],
		},
	],
};

export function useStudentTopicRecipients(search?: string | null, studentFilterInput?: StudentFilterInput) {
	const baseFilter = { search, ...baseStudentTopicRecipientFilter };

	return useStudentNamesDescriptionsAndImagesQuery({
		variables: {
			filters: studentFilterInput ? mergeFilterInputs(baseFilter, studentFilterInput) : baseFilter,
		},
	});
}
